import DescriptionIcon from "@mui/icons-material/Description";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import EventNoteIcon from "@mui/icons-material/EventNote";
import PaidIcon from "@mui/icons-material/Paid";
import InsightsIcon from "@mui/icons-material/Insights";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import GavelIcon from "@mui/icons-material/Gavel";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import TuneIcon from "@mui/icons-material/Tune";
import SensorsIcon from "@mui/icons-material/Sensors";
import TableChartIcon from "@mui/icons-material/TableChart";
import FactoryIcon from "@mui/icons-material/Factory";
import BuildIcon from "@mui/icons-material/Build";
import HandymanIcon from "@mui/icons-material/Handyman";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import EngineeringIcon from "@mui/icons-material/Engineering";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import StorageIcon from "@mui/icons-material/Storage";
import FactCheckIcon from "@mui/icons-material/FactCheck";

/**
 * Procurement registers rendered under every project, with the path and
 * payload keys each one reads from.
 */
export const PROCUREMENT_CATEGORIES = [
  {
    key: "mrq",
    label: "MRQ",
    icon: ShoppingCartIcon,
    pathKey: "plantMRQ",
    apiKey: "mrqs",
  },
  {
    key: "vendorBidEvaluation",
    label: "Vendor Bid Evaluation",
    icon: GavelIcon,
    pathKey: "plantVendorBidEvaluation",
    apiKey: "bids",
  },
  {
    key: "po",
    label: "PO",
    icon: ReceiptIcon,
    pathKey: "plantPO",
    apiKey: "pos",
  },
  {
    key: "mrv",
    label: "MRV",
    icon: LocalShippingIcon,
    pathKey: "plantMRV",
    apiKey: "mrvs",
  },
  {
    key: "srv",
    label: "SRV",
    icon: AssignmentReturnIcon,
    pathKey: "plantSRV",
    apiKey: "srvs",
  },
];

/**
 * The listed sections under each project - everything below is a placeholder:
 * nothing is fetched for them and clicking one does nothing, so they carry no
 * selection-target entry (node selection ignores ids it doesn't know). They
 * are here to show what a project is meant to hold; each becomes a link as
 * the page behind it arrives.
 */
export const PROJECT_CONTROL_ITEMS = [
  { key: "dcs", label: "Document Control System", icon: DescriptionIcon },
  {
    key: "fcs",
    label: "Fabrication Control System",
    icon: PrecisionManufacturingIcon,
  },
  { key: "schedule", label: "Schedule", icon: EventNoteIcon },
  { key: "cost-control", label: "Cost Control", icon: PaidIcon },
  { key: "project-schedule", label: "Project Schedule", icon: EventNoteIcon },
  {
    key: "project-cost-control",
    label: "Project Cost Control",
    icon: PaidIcon,
  },
  {
    key: "mis",
    label: "MIS - Management Information System",
    icon: InsightsIcon,
  },
];

/**
 * The "Dashboard" section. Two of these do have a page already - MCS's
 * Equipment List (Major Equipments) and its BOM Dashboard (Bulk Materials) -
 * and the valve and instrument ones do not: MCS holds valves and instruments
 * in one "Valves & Instrumentation" tab rather than a dashboard each. All
 * four are listed the same way until the dashboards behind them exist.
 */
export const DASHBOARD_ITEMS = [
  { key: "valve-list", label: "Valve List Dashboard", icon: TuneIcon },
  {
    key: "equipment-list",
    label: "Equipment List Dashboard",
    icon: PrecisionManufacturingIcon,
  },
  {
    key: "instrument-list",
    label: "Instrument List Dashboard",
    icon: SensorsIcon,
  },
  {
    key: "drawing-bom",
    label: "Drawing BOM Dashboard",
    icon: TableChartIcon,
  },
];

/** The "AIMS" section - Asset Integrity Management. */
export const AIMS_ITEMS = [
  { key: "plant-data", label: "Plant Data", icon: FactoryIcon },
  {
    key: "maintenance-projects",
    label: "Maintenance Projects",
    icon: BuildIcon,
  },
  {
    key: "modification-projects",
    label: "Modification Projects",
    icon: HandymanIcon,
  },
  { key: "digital-twin", label: "Digital Twin", icon: ViewInArIcon },
  {
    key: "cmms",
    label: "Computerized Maintenance Management System",
    icon: EngineeringIcon,
  },
  { key: "spares", label: "Spares", icon: Inventory2Icon },
];

/** The "Client Data" section. */
export const CLIENT_DATA_ITEMS = [
  { key: "data-historian", label: "Data Historian", icon: StorageIcon },
];

/** The "Validation" section. */
export const VALIDATION_ITEMS = [
  {
    key: "validation-software",
    label: "Validation Software",
    icon: FactCheckIcon,
  },
];

/**
 * The sections rendered under a project after Procurement, in this order.
 * Each is a folder of its own: it opens and closes on a click, and comes up
 * closed (see PlantNode).
 */
export const PLACEHOLDER_SECTIONS = [
  {
    key: "project-control",
    label: "Project Control",
    items: PROJECT_CONTROL_ITEMS,
  },
  { key: "dashboard", label: "Dashboard", items: DASHBOARD_ITEMS },
  { key: "aims", label: "AIMS", items: AIMS_ITEMS },
  { key: "client-data", label: "Client Data", items: CLIENT_DATA_ITEMS },
  { key: "validation", label: "Validation", items: VALIDATION_ITEMS },
];
